export function dashboardGroupsJson (language) {
  let items

  if (language === 'es') {
    items = {
      addUsers: {
        name: 'addUsers',
        label: 'agregar usuarios'
      },
      deleteUsers: {
        name: 'deleteUsers',
        label: 'eliminar usuarios'
      },
      selectRowsDataTableUsers: {
        name: 'selectRowsDataTableUsers',
        label: 'seleccionar filas de la tabla de datos de usuarios'
      },
      addDevices: {
        name: 'addDevices',
        label: 'agregar dispositivos'
      },
      deleteDevices: {
        name: 'deleteDevices',
        label: 'eliminar dispositivos'
      },
      selectRowsDataTableDevices: {
        name: 'selectRowsDataTableDevices',
        label: 'seleccionar filas de la tabla de datos de dispositivos'
      },
      addGeofences: {
        name: 'addGeofences',
        label: 'agregar geocercas'
      },
      deleteGeofences: {
        name: 'deleteGeofences',
        label: 'eliminar geocercas'
      },
      selectRowsDataTableGeofences: {
        name: 'selectRowsDataTableGeofences',
        label: 'seleccionar filas de la tabla de datos de geocercas'
      },
      // buttonSpeedDial: {
      //   name: 'buttonSpeedDial',
      //   label: 'mostrar el botón del menu de accciones'
      // },
      actionShutdown: {
        name: 'actionShutdown',
        label: 'apagar dispositivos'
      },
      actionReboot: {
        name: 'actionReboot',
        label: 'reiniciar dispositivos'
      },
      actionSendMessage: {
        name: 'actionSendMessage',
        label: 'enviar mensaje'
      },
      actionContentDownload: {
        name: 'actionContentDownload',
        label: 'descargar contenido en los dispositivos'
      },
      actionBackgroundChange: {
        name: 'actionBackgroundChange',
        label: 'cambiar el fondo de pantalla en los dispositivos'
      },
      actionLockDevices: {
        name: 'actionLockDevices',
        label: 'bloquear dispositivos'
      },
      actionUnlockDevices: {
        name: 'actionUnlockDevices',
        label: 'desbloquear dispositivos'
      },
      actionUseTimePreferences: {
        name: 'actionUseTimePreferences',
        label: 'cambiar las preferencias del tiempo de uso de los dispositivos'
      },
      actionDeletePreferences: {
        name: 'actionDeletePreferences',
        label: 'eliminar las preferencias del grupo'
      },
      actionInstallApplication: {
        name: 'actionInstallApplication',
        label: 'instalar aplicaciones a los dispositivos del grupo'
      },
      actionUninstallApplication: {
        name: 'actionUninstallApplication',
        label: 'desinstalar aplicaciones a los dispositivos del grupo'
      },
      actionLeasingGroup: {
        name: 'actionLeasingGroup',
        label: 'arrendamiento de los dispositivos del grupo'
      }
    }
  } else if (language === 'en') {
    items = {
      addUsers: {
        name: 'addUsers',
        label: 'add users'
      },
      deleteUsers: {
        name: 'deleteUsers',
        label: 'delete users'
      },
      selectRowsDataTableUsers: {
        name: 'selectRowsDataTableUsers',
        label: 'select rows from the user data table'
      },
      addDevices: {
        name: 'addDevices',
        label: 'add devices'
      },
      deleteDevices: {
        name: 'deleteDevices',
        label: 'delete devices'
      },
      selectRowsDataTableDevices: {
        name: 'selectRowsDataTableDevices',
        label: 'select rows from the device data table'
      },
      addGeofences: {
        name: 'addGeofences',
        label: 'add geofences'
      },
      deleteGeofences: {
        name: 'deleteGeofences',
        label: 'delete geofences'
      },
      selectRowsDataTableGeofences: {
        name: 'selectRowsDataTableGeofences',
        label: 'select rows from the geofence data table'
      },
      // buttonSpeedDial: {
      //   name: 'buttonSpeedDial',
      //   label: 'mostrar el botón del menu de accciones'
      // },
      actionShutdown: {
        name: 'actionShutdown',
        label: 'turn off devices'
      },
      actionReboot: {
        name: 'actionReboot',
        label: 'reboot devices'
      },
      actionSendMessage: {
        name: 'actionSendMessage',
        label: 'send message'
      },
      actionContentDownload: {
        name: 'actionContentDownload',
        label: 'download content to devices'
      },
      actionBackgroundChange: {
        name: 'actionBackgroundChange',
        label: 'change the wallpaper on devices'
      },
      actionLockDevices: {
        name: 'actionLockDevices',
        label: 'lock devices'
      },
      actionUnlockDevices: {
        name: 'actionUnlockDevices',
        label: 'unlock devices'
      },
      actionUseTimePreferences: {
        name: 'actionUseTimePreferences',
        label: 'change device usage time preferences'
      },
      actionDeletePreferences: {
        name: 'actionDeletePreferences',
        label: 'delete group preferences'
      },
      actionInstallApplication: {
        name: 'actionInstallApplication',
        label: 'install apps to the devices of the group'
      },
      actionUninstallApplication: {
        name: 'actionUninstallApplication',
        label: 'uninstall apps to the devices of the group'
      },
      actionLeasingGroup: {
        name: 'actionLeasingGroup',
        label: 'leasing to the devices of group'
      }
    }
  }

  return (items)
}
